import 'react-loading-skeleton/dist/skeleton.css';

import Skeleton from 'react-loading-skeleton';

import styles from './skeletonLoader.module.scss';

export interface SkeletonLoaderProps {
  count?: number;
  height?: number;
  width?: string;
  style?: React.CSSProperties;
}

const SkeletonLoader = ({ count = 10, height = 32, width = '100%', style }: SkeletonLoaderProps) => {
  return <Skeleton count={count} className={styles.skeleton} height={height} width={width} style={style} />;
};

export default SkeletonLoader;
